// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mark-down {
    display: block;
    font-size: var(--font-size);
    max-width: var(--markdown-max-width);
    min-width: 320px;
    margin: auto;
    padding-right: var(--markdown-aside-width);
    color: var(--foreground-color);
    visibility: hidden;
}

mark-down[rendered] {
    visibility: visible;
}

mark-down link-tag {
    color: var(--highlight-color);
    background-color: var(--secondary-highlight-color);
}

mark-down .task-list-ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

mark-down ul.contains-task-list {
    list-style: none;
    padding: 0;
    margin: 0;

}

mark-down ul.contains-task-list li {
    padding: 0;
}


mark-down h1,
mark-down h2,
mark-down h3,
mark-down h4 {
    font-weight: 400;
    font-style: italic;
    margin-top: 1.2361em;
    margin-bottom: 1.2361rem;
}

mark-down h1 {
    font-size: var(--h1-font-size);
}

mark-down h2 {
    font-size: var(--h2-font-size);
}

mark-down h3 {
    font-size: var(--h3-font-size);
}

mark-down p,
mark-down dl,
mark-down ol,
mark-down ul {
    font-size: var(--font-size);
    line-height: var(--line-height);
}

mark-down a {
    color: var(--link-color);
}


mark-down p {
    margin-top: 1.4rem;
    margin-bottom: 1.4rem;
    vertical-align: baseline;
}

mark-down aside {
    width: var(--markdown-aside-width);
    float: right;
    clear: right;
    margin-right: calc(var(--markdown-aside-width) * -1);
    width: calc(var(--markdown-aside-width) - 4rem);
    margin-top: 0.3rem;
    margin-bottom: 0;
    line-height: 0.8;
    vertical-align: baseline;
    position: relative;
    padding-right: 0.5em;

}

mark-down figure {
    max-width: 90%;
}

mark-down figure img {
    max-width: 100%;
    margin: auto;
}

mark-down figcaption {
    margin-right: 0%;
    margin-left: auto;
    max-width: none;
    max-width: 80%;
    font-size: 80%;
    font-style: italic;
    text-align: right;
}

mark-down blockquote {
    margin-left: 1.5em;
    margin-right: 0em;
    font-size: 130%;
    font-style: italic;
}

mark-down blockquote p,
mark-down blockquote footer {
    width: 100%;
}

mark-down hr {
  border: none;
  margin: 3em 0;
  height: 1pt;
  background-color: var(--neutral-bg-color);
}

/* Scrollbar styling for mark-down component */
/* Firefox */
mark-down,
mark-down * {
    scrollbar-color: var(--neutral-fg-color) var(--neutral-bg-color);
    scrollbar-width: thin;
}

/* Chromium, Safari, Edge */
mark-down *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

mark-down *::-webkit-scrollbar-track {
    background: var(--neutral-bg-color);
}

mark-down *::-webkit-scrollbar-thumb {
    background-color: var(--neutral-fg-color);
    border-radius: 8px;
    border: 2px solid var(--neutral-bg-color);
}

mark-down *::-webkit-scrollbar-thumb:hover {
    background-color: var(--secondary-color);
}

mark-down *::-webkit-scrollbar-thumb:active {
    background-color: var(--highlight-color);
}

mark-down *::-webkit-scrollbar-corner {
    background: var(--neutral-bg-color);
}

/* Checkbox styling for mark-down component */
/* Native accent-color (modern browsers) */
mark-down input[type="checkbox"] {
    accent-color: var(--highlight-color);
    width: 1rem;
    height: 1rem;
    vertical-align: text-bottom;
    border: 2px solid var(--neutral-fg-color);
    border-radius: 0.2rem;
    background-color: var(--background-color);
    cursor: pointer;
}

mark-down input[type="checkbox"]:hover:not(:disabled) {
    border-color: var(--secondary-color);
}

mark-down input[type="checkbox"]:checked {
    border-color: var(--highlight-color);
}

mark-down input[type="checkbox"]:focus-visible {
    outline: 2px solid var(--trinary-color);
    outline-offset: 2px;
}

mark-down input[type="checkbox"]:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}


/* Fallback for browsers without accent-color support */
@supports not (accent-color: red) {
    mark-down input[type="checkbox"] {
        -webkit-appearance: none;
        appearance: none;
        background-color: var(--background-color);
        display: inline-grid;
        place-content: center;
    }

    mark-down input[type="checkbox"]::before {
        content: "";
        width: 0.55rem;
        height: 0.55rem;
        transform: scale(0);
        transition: transform 120ms ease-in-out;
        box-shadow: inset 1rem 1rem var(--highlight-color);
        clip-path: polygon(14% 44%, 0 59%, 44% 100%, 100% 34%, 87% 20%, 44% 62%);
    }

    mark-down input[type="checkbox"]:checked::before {
        transform: scale(1);
    }
}`, "",{"version":3,"sources":["webpack://./styles/mark-down.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,2BAA2B;IAC3B,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,0CAA0C;IAC1C,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;;AAEb;;AAEA;IACI,UAAU;AACd;;;AAGA;;;;IAII,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;;;IAII,2BAA2B;IAC3B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,oDAAoD;IACpD,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;;AAExB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,yCAAyC;AAC3C;;AAEA,8CAA8C;AAC9C,YAAY;AACZ;;IAEI,gEAAgE;IAChE,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;AACvC;;AAEA,6CAA6C;AAC7C,0CAA0C;AAC1C;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;IACrB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;AAGA,uDAAuD;AACvD;IACI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,yCAAyC;QACzC,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,mBAAmB;QACnB,uCAAuC;QACvC,kDAAkD;QAClD,wEAAwE;IAC5E;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["mark-down {\n    display: block;\n    font-size: var(--font-size);\n    max-width: var(--markdown-max-width);\n    min-width: 320px;\n    margin: auto;\n    padding-right: var(--markdown-aside-width);\n    color: var(--foreground-color);\n    visibility: hidden;\n}\n\nmark-down[rendered] {\n    visibility: visible;\n}\n\nmark-down link-tag {\n    color: var(--highlight-color);\n    background-color: var(--secondary-highlight-color);\n}\n\nmark-down .task-list-ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\nmark-down ul.contains-task-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n\n}\n\nmark-down ul.contains-task-list li {\n    padding: 0;\n}\n\n\nmark-down h1,\nmark-down h2,\nmark-down h3,\nmark-down h4 {\n    font-weight: 400;\n    font-style: italic;\n    margin-top: 1.2361em;\n    margin-bottom: 1.2361rem;\n}\n\nmark-down h1 {\n    font-size: var(--h1-font-size);\n}\n\nmark-down h2 {\n    font-size: var(--h2-font-size);\n}\n\nmark-down h3 {\n    font-size: var(--h3-font-size);\n}\n\nmark-down p,\nmark-down dl,\nmark-down ol,\nmark-down ul {\n    font-size: var(--font-size);\n    line-height: var(--line-height);\n}\n\nmark-down a {\n    color: var(--link-color);\n}\n\n\nmark-down p {\n    margin-top: 1.4rem;\n    margin-bottom: 1.4rem;\n    vertical-align: baseline;\n}\n\nmark-down aside {\n    width: var(--markdown-aside-width);\n    float: right;\n    clear: right;\n    margin-right: calc(var(--markdown-aside-width) * -1);\n    width: calc(var(--markdown-aside-width) - 4rem);\n    margin-top: 0.3rem;\n    margin-bottom: 0;\n    line-height: 0.8;\n    vertical-align: baseline;\n    position: relative;\n    padding-right: 0.5em;\n\n}\n\nmark-down figure {\n    max-width: 90%;\n}\n\nmark-down figure img {\n    max-width: 100%;\n    margin: auto;\n}\n\nmark-down figcaption {\n    margin-right: 0%;\n    margin-left: auto;\n    max-width: none;\n    max-width: 80%;\n    font-size: 80%;\n    font-style: italic;\n    text-align: right;\n}\n\nmark-down blockquote {\n    margin-left: 1.5em;\n    margin-right: 0em;\n    font-size: 130%;\n    font-style: italic;\n}\n\nmark-down blockquote p,\nmark-down blockquote footer {\n    width: 100%;\n}\n\nmark-down hr {\n  border: none;\n  margin: 3em 0;\n  height: 1pt;\n  background-color: var(--neutral-bg-color);\n}\n\n/* Scrollbar styling for mark-down component */\n/* Firefox */\nmark-down,\nmark-down * {\n    scrollbar-color: var(--neutral-fg-color) var(--neutral-bg-color);\n    scrollbar-width: thin;\n}\n\n/* Chromium, Safari, Edge */\nmark-down *::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n\nmark-down *::-webkit-scrollbar-track {\n    background: var(--neutral-bg-color);\n}\n\nmark-down *::-webkit-scrollbar-thumb {\n    background-color: var(--neutral-fg-color);\n    border-radius: 8px;\n    border: 2px solid var(--neutral-bg-color);\n}\n\nmark-down *::-webkit-scrollbar-thumb:hover {\n    background-color: var(--secondary-color);\n}\n\nmark-down *::-webkit-scrollbar-thumb:active {\n    background-color: var(--highlight-color);\n}\n\nmark-down *::-webkit-scrollbar-corner {\n    background: var(--neutral-bg-color);\n}\n\n/* Checkbox styling for mark-down component */\n/* Native accent-color (modern browsers) */\nmark-down input[type=\"checkbox\"] {\n    accent-color: var(--highlight-color);\n    width: 1rem;\n    height: 1rem;\n    vertical-align: text-bottom;\n    border: 2px solid var(--neutral-fg-color);\n    border-radius: 0.2rem;\n    background-color: var(--background-color);\n    cursor: pointer;\n}\n\nmark-down input[type=\"checkbox\"]:hover:not(:disabled) {\n    border-color: var(--secondary-color);\n}\n\nmark-down input[type=\"checkbox\"]:checked {\n    border-color: var(--highlight-color);\n}\n\nmark-down input[type=\"checkbox\"]:focus-visible {\n    outline: 2px solid var(--trinary-color);\n    outline-offset: 2px;\n}\n\nmark-down input[type=\"checkbox\"]:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n\n/* Fallback for browsers without accent-color support */\n@supports not (accent-color: red) {\n    mark-down input[type=\"checkbox\"] {\n        -webkit-appearance: none;\n        appearance: none;\n        background-color: var(--background-color);\n        display: inline-grid;\n        place-content: center;\n    }\n\n    mark-down input[type=\"checkbox\"]::before {\n        content: \"\";\n        width: 0.55rem;\n        height: 0.55rem;\n        transform: scale(0);\n        transition: transform 120ms ease-in-out;\n        box-shadow: inset 1rem 1rem var(--highlight-color);\n        clip-path: polygon(14% 44%, 0 59%, 44% 100%, 100% 34%, 87% 20%, 44% 62%);\n    }\n\n    mark-down input[type=\"checkbox\"]:checked::before {\n        transform: scale(1);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
